import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

const HiringRequirements = ({ employee, isHRView }) => {
    const [requirements, setRequirements] = useState([]);

    const fetchRequirements = async () => {
        if (!employee?.company_name) return;
        try {
            const res = await axios.get(`${API_BASE_URL}/api/requirements`, {
                params: { companyName: employee.company_name },
            });
            setRequirements(res.data);
        } catch (err) {
            console.error("Error fetching requirements:", err);
        }
    };

    useEffect(() => {
        fetchRequirements();
    }, [employee.company_name]);

    // Generate referral link
    const generateReferralLink = (req) =>
        `${window.location.origin}/candidate-apply/${req._id}?referral=${employee._id}`;

    // Share via social platforms
    const handleSocialShare = (req, platform) => {
        const referralLink = generateReferralLink(req);
        let shareUrl = "";

        switch (platform) {
            case "whatsapp":
                shareUrl = `https://wa.me/?text=${encodeURIComponent(
                    `Check out this job opening at ${req.companyName}: ${req.position}\n\n${referralLink}`
                )}`;
                break;

            case "linkedin":
                shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                    referralLink
                )}`;
                break;

            case "twitter":
                shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
                    `Check out this job opening: ${req.position} at ${req.companyName}`
                )}&url=${encodeURIComponent(referralLink)}`;
                break;

            default:
                return;
        }

        window.open(shareUrl, "_blank");
    };

    const copyToClipboard = (req) => {
        const referralLink = generateReferralLink(req);
        navigator.clipboard.writeText(referralLink).then(() => {
            alert('Link copied to clipboard!');
        });
    };

    return (
        <div className="ed-tab-panel ed-animate-fadeIn">
            <h3 className="ed-panel-title">Hiring Requirements - {employee.company_name}</h3>

            <div className="ed-requirements-list">
                {requirements.length > 0 ? (
                    requirements.map((req) => (
                        <div key={req._id} className="ed-requirement-card ed-animate-slideIn">
                            <h4>{req.position}</h4>
                            <p><strong>Department:</strong> {req.department}</p>
                            <p><strong>Vacancies:</strong> {req.vacancies}</p>
                            <p>{req.description}</p>
                            <p><strong>Added By:</strong> {req.hiringManager}</p>

                            {/* Social Share Buttons */}
                            <div className="social-share-buttons">
                                <button 
                                    onClick={() => handleSocialShare(req, "whatsapp")}
                                    className="share-btn whatsapp-btn"
                                >
                                    WhatsApp
                                </button>
                                <button 
                                    onClick={() => handleSocialShare(req, "linkedin")}
                                    className="share-btn linkedin-btn"
                                >
                                    LinkedIn
                                </button>
                                <button 
                                    onClick={() => handleSocialShare(req, "twitter")}
                                    className="share-btn twitter-btn"
                                >
                                    Twitter
                                </button>
                                <button 
                                    onClick={() => copyToClipboard(req)}
                                    className="share-btn copy-btn"
                                >
                                    Copy Link
                                </button>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No hiring requirements available.</p>
                )}
            </div>
        </div>
    );
};

export default HiringRequirements;